import img1 from "../../assets/Images/Reports/Event-Report.png"

export default function EventReport() {
  return (
    <section id="event-report" className="space-y-16">

      {/* SECTION TITLE */}

      <section className="bg-white rounded-xl border border-slate-200 p-10">
        <h1 className="text-2xl font-bold text-slate-900 mb-2">
          1. Event Report
        </h1>
        <p className="text-md text-slate-600 max-w-3xl">
          The Event Report provides a consolidated view of booking receipts,
          received payments, and outstanding balances within a selected receipt
          date range.
        </p>


        {/* OVERVIEW */}
        <section className="bg-white border-l border-[#C9A24E] p-4 mt-2">
          <h2 className="text-lg font-semibold mb-3">
            Overview
          </h2>
          <p className="text-slate-600 text-sm">
            This report is primarily used by management and accounts teams to
            monitor cash flow, track received amounts against bookings, and
            identify outstanding balances. It aggregates receipt vouchers linked
            with event bookings and presents them in a tabular format.
          </p>
        </section>
      </section>
      

      {/* FILTERS */}
      <section className="">
        <div>
          <h3 className="font-semibold mb-2">
            Receipt Date Filters
          </h3>
          <p className="text-slate-600 mb-3">
            The Event Report can be filtered using a receipt date range. This
            allows you to analyze payments received during a specific period,
            regardless of the actual event date.
          </p>

          <ul className="list-disc pl-5 text-slate-600 space-y-1">
            <li>Start Receipt Date</li>
            <li>End Receipt Date</li>
            <li>Date filter applies to receipt entries only</li>
            <li>Helps in daily, weekly, or monthly cash analysis</li>
          </ul>
        </div>
      </section>

      {/* TABLE */}
      <section className="bg-white border border-slate-200 rounded-xl p-8">
        <h3 className="font-semibold mb-3">
          Event Report Table
        </h3>

        <p className="text-slate-600 mb-4">
          The report table displays all receipt entries associated with bookings
          falling within the selected receipt date range.
        </p>

        <ul className="list-disc pl-5 text-slate-600 space-y-1">
          <li>Receipt Voucher Number (RV No)</li>
          <li>Booking Number</li>
          <li>Booking Date</li>
          <li>Receipt Date</li>
          <li>Total Booking Amount</li>
          <li>Received Amount</li>
          <li>Remaining Balance</li>
          <li>Payment Method (Cash / Online)</li>
        </ul>

        <div className="rounded-lg p-4 mt-4">
          <img src={img1} alt="" />
        </div>
      </section>

      {/* TOTALS */}
      <section className="bg-slate-100 rounded-xl p-8 ">
        <h3 className="font-semibold mb-2">
          Automatic Totals Calculation
        </h3>

        <p className="text-slate-600 mb-3">
          At the bottom of the report table, EventFlow automatically calculates
          cumulative totals for the selected date range.
        </p>

        <ul className="list-disc pl-5 text-slate-600 space-y-1">
          <li>Total Booking Amount</li>
          <li>Total Received Amount</li>
          <li>Total Outstanding Balance</li>
        </ul>

        <p className="text-slate-600 mt-3">
          These totals help management quickly assess overall revenue and pending
          recoveries without manual calculations.
        </p>
      </section>

      {/* SEARCH */}
      <section className="bg-white border border-slate-200 rounded-xl p-8">
        <h3 className="font-semibold mb-2">
          Search Within Report
        </h3>

        <p className="text-slate-600 mb-3">
          The search box above the table allows instant filtering of report rows.
        </p>

        <ul className="list-disc pl-5 text-slate-600 space-y-1">
          <li>Search by Booking Number</li>
          <li>Search by Receipt Voucher Number</li>
          <li>Search by payment method</li>
        </ul>
      </section>

      {/* EXPORT */}
      <section className="bg-[#C9A24E]/10 rounded-xl p-8">
        <h3 className="font-semibold mb-2">
          Export Options (Excel & PDF)
        </h3>

        <p className="text-slate-600 mb-3">
          EventFlow allows exporting the Event Report for offline analysis and
          record keeping.
        </p>

        <ul className="list-disc pl-5 text-slate-600 space-y-1">
          <li>Export report in Excel format</li>
          <li>Export report as a PDF document</li>
          <li>Exports respect applied date filters</li>
          <li>Useful for audits and management reporting</li>
        </ul>
      </section>

      {/* WHY IMPORTANT */}
      <section className="bg-slate-100 rounded-xl p-8">
        <h3 className="font-semibold mb-2">
          Why Event Report Is Important
        </h3>

        <p className="text-slate-600 max-w-3xl">
          The Event Report bridges the gap between bookings and actual revenue
          realization. It ensures transparency, improves financial control, and
          helps management identify pending payments early.
        </p>
      </section>

    </section>
  );
}
